module.exports = __webpack_public_path__ + "static/img/孔晓霞总裁.c3c68a70.png";